export default __webpack_public_path__ + "static/media/castores-logo.36208d85.jpg";